import { Payload, payloadSchema } from 'embedded/api/in/messages/Payload';
import { JSONSchemaType } from 'ajv';

export interface SetOrderIdsMessagePayload extends Payload {
    orderIds: string[];
}

export const setOrderIdsPayloadSchema: JSONSchemaType<SetOrderIdsMessagePayload> =
    {
        type: 'object',
        properties: {
            ...payloadSchema.properties,
            orderIds: {
                type: 'array',
                items: {
                    type: 'string',
                    minLength: 1,
                },
            },
        },
        required: ['orderIds'],
        additionalProperties: false,
    };
